var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
/** Uma leitura crua dentro do detalhamento de uma celula. */
let BucketReadingScope = class BucketReadingScope extends Scope {
    constructor() {
        super(...arguments);
        /** `16:04:22` - so a hora, porque o dia ja esta no titulo do dialogo. */
        this.time = '';
        this.value = '';
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], BucketReadingScope.prototype, "time", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], BucketReadingScope.prototype, "value", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], BucketReadingScope.prototype, "statusColor", void 0);
__decorate([
    observe(),
    __metadata("design:type", String)
], BucketReadingScope.prototype, "statusName", void 0);
BucketReadingScope = __decorate([
    Observable
], BucketReadingScope);
export { BucketReadingScope };
/**
 * O balde aberto - as leituras que UMA celula do historico resumiu.
 *
 * A tabela agrupa por hora, entao a celula deixou de ser uma leitura. Isto e o que
 * devolve as leituras a quem clica: sem ele, agrupar teria TIRADO informacao que a
 * tela tinha.
 */
let BucketReadingsScope = class BucketReadingsScope extends Scope {
    constructor() {
        super(...arguments);
        this.open = false;
        /** `Frequencia Cardiaca - 14/09/2026 - 16:00`, o cabecalho do dialogo. */
        this.title = '';
        this.loading = false;
        this.readings = [];
        this.onClose = Scope.ASYNC_ACTION;
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], BucketReadingsScope.prototype, "open", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], BucketReadingsScope.prototype, "title", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], BucketReadingsScope.prototype, "loading", void 0);
__decorate([
    observe(),
    __metadata("design:type", Array)
], BucketReadingsScope.prototype, "readings", void 0);
BucketReadingsScope = __decorate([
    Observable
], BucketReadingsScope);
export { BucketReadingsScope };
//# sourceMappingURL=bucket-readings.scope.js.map